<div class="application-login-form">
  <h2 class="application-login-form__heading ta-center">Setup Location</h2>
  <p class="form-subtitle ta-center">Enterprise Location Information</p>

  <div class="application-card">
    <form [formGroup]="form" (ngSubmit)="createLocation()">
      <div class="form-columns">
        <mat-form-field class="w-100 d-block" floatLabel="always">
          <mat-label>Location Name *</mat-label>
          <input matInput type="text" formControlName="locationName" required />
          <mat-error *ngIf="form.get('locationName')?.hasError('required')">
            Location Name is required.
          </mat-error>
        </mat-form-field>

        <mat-form-field class="w-100 d-block" floatLabel="always">
          <mat-label>Location Street *</mat-label>
          <input
            matInput
            type="text"
            formControlName="locationStreet"
            required
          />
          <mat-error *ngIf="form.get('locationStreet')?.hasError('required')">
            Street Address is required.
          </mat-error>
        </mat-form-field>

        <mat-form-field class="w-100 d-block" floatLabel="always">
          <mat-label>City *</mat-label>
          <input matInput type="text" formControlName="locationCity" required />
          <mat-error *ngIf="form.get('locationCity')?.hasError('required')">
            City is required.
          </mat-error>
        </mat-form-field>

        <div class="flex-row">
          <mat-form-field class="flex-item" floatLabel="always">
            <mat-label>State *</mat-label>
            <input
              matInput
              type="text"
              formControlName="locationState"
              required
            />
            <mat-error *ngIf="form.get('locationState')?.hasError('required')">
              State is required.
            </mat-error>
          </mat-form-field>

          <mat-form-field class="flex-item" floatLabel="always">
            <mat-label>Zip *</mat-label>
            <input
              matInput
              type="text"
              formControlName="locationZip"
              required
            />
            <mat-error *ngIf="form.get('locationZip')?.hasError('required')">
              Zip is required.
            </mat-error>
          </mat-form-field>
        </div>

        <mat-form-field class="w-100 d-block" floatLabel="always">
          <mat-label>Timezone *</mat-label>
          <mat-select formControlName="timezone" required>
            <mat-option
              *ngFor="let timezone of timezones"
              [value]="timezone.name"
            >
              {{ timezone.name }} ({{ timezone.abbrev }})
            </mat-option>
          </mat-select>
          <mat-error *ngIf="form.get('timezone')?.hasError('required')">
            Timezone is required.
          </mat-error>
        </mat-form-field>
      </div>

      <button
        mat-raised-button
        color="primary"
        type="submit"
        class="submit-button w-100"
        [disabled]="form.invalid"
        style="display: flex; flex-direction: row-reverse"
      >
        <span style="margin-right: 15px">Add Location</span>
        <mat-icon>keyboard_arrow_right</mat-icon>
      </button>
    </form>
  </div>
</div>

<style>
  .application-login-form {
    display: flex;
    flex-direction: column;
    align-items: center;
    min-height: 100vh;
    justify-content: center;
  }
  .application-card {
    background-color: white;
    padding: 30px;
    border-radius: 8px;
    width: 80%;
    max-width: 600px;
  }
  .form-columns {
    justify-content: space-between;
  }
  .form-left,
  .form-right {
    width: 48%;
  }
  .flex-row {
    display: flex;
    justify-content: space-between;
  }
  .flex-item {
    width: 48%;
  }
  .submit-button {
    margin-top: 30px;
    display: flex;
    flex-direction: row-reverse;
    align-items: center;
    justify-content: center;
  }
  .upload-button {
    position: relative;
  }
  .logo-upload-container {
    cursor: pointer;
  }
</style>
